import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookiePolicyComponent } from '../../cookie-policy/cookie-policy.component';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { AlertService } from '../../services/alert/alert.service';
import { AlertModel, Flow } from '../../model/alert.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const cookiePolicy = '11/06/2024';

@Component({
  selector: 'app-global-alert',
  templateUrl: './global-alert.component.html',
  standalone: false,
  styleUrls: ['./global-alert.component.scss']
})
export class GlobalAlertComponent {
  readonly alertService = inject(AlertService);
  private readonly modalService = inject(NgbModal);
  private readonly localStorageService = inject(LocalStorageService);

  @Input() globalAlert$!: Observable<AlertModel[]>;
  State = Flow;

  public openCookiePopUp(): void {
    this.modalService.open(CookiePolicyComponent, { centered: true, size: 'lg' });
  }

  public acceptPolicies(alert: AlertModel): void {
    this.alertService.closeAlert(alert);
    this.localStorageService.storeItem(cookiePolicy);
  }
}
